import React from 'react';
import PropTypes from 'prop-types';

const PropertySection = ({ children }) => {
  return <div className='border rounded-xl border-solid py-1 px-3 border-gray-200 dark:border-gray-800'>{children}</div>;
};

PropertySection.propTypes = {
  children: PropTypes.any,
};

export default PropertySection;
